import React from 'react'
import { Wrapper } from './AutoFormStyled'

export default function IncResBtn({ text, active, func }: any) {
  return (
    <Wrapper active={active} increase={text !== 'Reset'} onClick={func}>
      <div className='yellow' />
      <div className='white' />
      <p>{text}</p>
    </Wrapper>
  )
}
